import {CurrentRepositoryProvider} from '@github-ui/current-repository'
import {CurrentUserProvider} from '@github-ui/current-user'
import {UserNameDisplayContextProvider} from '@github-ui/profile-reference/UserNameDisplayContext'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import type React from 'react'
import {useState} from 'react'

import {CommitErrorState} from './components/CommitErrorState'
import type {CommitsBasePayload} from './shared/types'

/**
 * Renders the providers which are shared by all routes within this app. Data router routes render this
 * directly with the payload from their own route query; the shared values live on the layout route.
 */
export function AppWrapper({payload, children}: {payload: CommitsBasePayload; children?: React.ReactNode}) {
  const [repo] = useState(payload?.repo)
  const [user] = useState(payload?.currentUser)
  const [userNameDisplayConfiguration] = useState(payload?.userNameDisplayConfiguration)

  return (
    <ErrorBoundary critical fallback={<CommitErrorState />}>
      <CurrentUserProvider user={user}>
        <CurrentRepositoryProvider repository={repo}>
          <UserNameDisplayContextProvider value={userNameDisplayConfiguration ?? undefined}>
            {children}
          </UserNameDisplayContextProvider>
        </CurrentRepositoryProvider>
      </CurrentUserProvider>
    </ErrorBoundary>
  )
}
